<template>
  <div class="slide" :class="{ dibujando: dibujando, lista: lista }">
    <!-- {{slide}} -->
    <div class="slide-header">
      <div class="slide-number">{{ index }}</div>
      <h2 class="slide-title">
        <!-- `span` y no `template`: <template> no renderiza v-html, asi que el
             titulo desaparecia por completo. -->
        <span
          v-if="slide.type === 'metamorphosis'"
          v-html="md(slide.title1)"
        ></span>
        <span v-else v-html="md(slide.title)"></span>
      </h2>
      <div>
        <b-button size="sm" pill v-if="canRemake" @click="remake"><v-icon name="redo" scale="0.6"/></b-button>
      </div>
    </div>

    <div class="slide-content">
      <!-- Slide de Introducción -->
      <div v-if="slide.type === 'intro'" class="grid-2">
        <div class="text-section">
          <div class="intro-capsule">
            <p class="intro-text" v-html="md(slide.introText)"></p>
            <div class="subtitle" v-html="md(slide.subtitle)"></div>
          </div>
          <div class="info-box" v-for="i in 2" :key="i">
            <h3>
              {{ slide["infoBox" + i] && slide["infoBox" + i].icon }}
              <span v-html="md(slide['infoBox' + i] && slide['infoBox' + i].title)"></span>
            </h3>
            <p v-html="md(slide.infoBox1 && slide.infoBox1.content)"></p>
          </div>
        </div>
        <div class="main-image">
          <img
            v-if="
              slide.promptparaimagen1 &&
              slide.promptparaimagen1.startsWith('http')
            "
            :src="slide.promptparaimagen1"
            alt="Imagen generada para la introducción"
          />
          
        </div>
      </div>

      <!-- Slide de Estrategias -->
      <div v-else-if="slide.type === 'strategies'" class="grid-2">
        <div class="features">
          <div v-for="n in 4" :key="n">
            <div class="feature" v-if="slide['feature' + n]">
              <div class="feature-icon">
                {{ slide["feature" + n].icon }}
              </div>
              <div class="feature-content">
                <h4 v-html="md(slide['feature' + n].title)"></h4>
                <p v-html="md(slide['feature' + n].description)"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="main-image">
          <img
            v-if="
              slide.promptparaimagen1 &&
              slide.promptparaimagen1.startsWith('http')
            "
            :src="slide.promptparaimagen1"
            alt="Imagen generada para estrategias"
          />
          
        </div>
      </div>

      <!-- Slide de Caso Práctico -->
      <div v-else-if="slide.type === 'case-study'" class="grid-1">
        <div class="intro-capsule">
          <p class="intro-text" v-html="md(slide.introText)"></p>
          <div class="subtitle" v-html="md(slide.subtitle)"></div>
        </div>
        <div class="case-study-layout">
          <div class="observations-section  d-lg-block d-none">
            <h3 class="section-title" v-html="md(slide.observationsTitle)"></h3>
            <ul class="observations-list">
              <div v-for="i in 4" :key="i">
                <li v-if="slide['observation' + i]">
                  <span v-html="md(slide['observation' + i])"></span>
                </li>
              </div>
            </ul>

            <!-- FROM HERE -->
          </div>
          <div class="analysis-section d-lg-block d-none">
            <h3 class="section-title" v-html="md(slide.analysisTitle)"></h3>
            <p
              style="
                color: var(--text-secondary);
                font-size: 0.95rem;
                margin-bottom: 16px;
              "
              v-html="md(slide.analysisText)"
            ></p>
          </div>
          <!-- La tabla sale de la columna derecha y ocupa el ancho completo.
               Encajonada en media lamina, sus tres columnas quedaban de ~110px
               y el texto se partia en tres o cuatro lineas, mientras la mitad
               izquierda quedaba vacia debajo de las observaciones. -->
          <div class="case-table-full d-lg-block d-none">
            <table class="analysis-table">
              <thead>
                <tr>
                  <th v-for="i in 3" :key="i">
                    <span v-html="md(slide['tableHeader' + i])"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="i in 4" :key="i">
                  <td v-for="(cell, idx) in slide['tableRow' + i]" :key="idx">
                    <span v-html="md(cell)"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="case-image-full">
            <img
              v-if="
                slide.promptparaimagen1 &&
                slide.promptparaimagen1.startsWith('http')
              "
              :src="slide.promptparaimagen1"
              alt="Imagen generada para el caso práctico"
            />
            
          </div>
        </div>
      </div>

      <!-- Slide de Metamorfosis -->
      <div v-else-if="slide.type === 'metamorphosis'" class="grid-1">
        <div class="metamorphosis-intro">
          <h2 class="slide-title" v-html="md(slide.title1)"></h2>
          <p class="intro-text" v-html="md(slide.introText1)"></p>
          <div class="subtitle" v-html="md(slide.subtitle1)"></div>
        </div>
        <div class="metamorphosis-grid-large">
          <div class="stage-card-large">
            <div class="stage-image-large">
              <img
                v-if="
                  slide.promptimagen1 && slide.promptimagen1.startsWith('http')
                "
                :src="slide.promptimagen1"
                :alt="slide.title2"
              />
              
            </div>
            <div class="stage-info">
              <h4>{{ slide.icon1 }} <span v-html="md(slide.title2)"></span></h4>
              <p v-html="md(slide.description1)"></p>
            </div>
          </div>
          <div class="stage-card-large">
            <div class="stage-image-large">
              <img
                v-if="
                  slide.promptimagen2 && slide.promptimagen2.startsWith('http')
                "
                :src="slide.promptimagen2"
                :alt="slide.title3"
              />
              
            </div>
            <div class="stage-info">
              <h4>{{ slide.icon2 }} <span v-html="md(slide.title3)"></span></h4>
              <p v-html="md(slide.description2)"></p>
            </div>
          </div>
          <div class="stage-card-large">
            <div class="stage-image-large">
              <img
                v-if="
                  slide.promptimagen3 && slide.promptimagen3.startsWith('http')
                "
                :src="slide.promptimagen3"
                :alt="slide.title4"
              />
              
            </div>
            <div class="stage-info">
              <h4>{{ slide.icon3 }} <span v-html="md(slide.title4)"></span></h4>
              <p v-html="md(slide.description3)"></p>
            </div>
          </div>
        </div>
      </div>

      <!-- Slide de Desarrollo de Ideas -->
      <div v-else-if="slide.type === 'development'" class="grid-1">
        <h2 class="slide-title" v-html="md(slide.title)"></h2>
        <div class="top-image">
          <img
            v-if="slide.promptimage1 && slide.promptimage1.startsWith('http')"
            :src="slide.promptimage1"
            alt="Imagen generada para desarrollo de ideas"
          />
          
        </div>
        <div class="grid-2x2">
          <div v-for="i in 4" :key="i">
            <div class="text-item" v-if="slide['item' + i]">
              <h3>
                <span class="emoji">{{ slide["item" + i].emoji }}</span
                ><span v-html="md(slide['item' + i].title)"></span>
              </h3>
              <p v-html="md(slide['item' + i].description)"></p>
            </div>
          </div>
        </div>
      </div>

      <!-- Slide de Ejercicio Multiple Choice -->
      <div v-else-if="slide.type === 'exercise-multiple'" class="grid-1">
        <div class="exercise-question">
          <h3 v-html="md(slide.question)"></h3>
        </div>
        <div class="exercise-options">
          <div v-for="i in 4" :key="i">
            <div
              class="option-card"
              v-if="slide['option' + i]"
              :class="{ 'correct-option': slide['option' + i].isCorrect }"
            >
              <div class="option-letter">
                {{ { 1: "A", 2: "B", 3: "C", 4: "D" }[i] }}
              </div>
              <div class="option-content-wrapper">
                <p v-html="md(slide['option' + i].text)"></p>
                <div v-if="slide['option' + i].isCorrect" class="correct-badge">
                  <span class="badge-icon">✅</span>
                  <span class="badge-text">¡Respuesta Correcta!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="slide.explanation" class="answer-explanation">
          <div class="explanation-header">
            <span class="explanation-icon">💡</span>
            <h4>Explicación</h4>
          </div>
          <p v-html="md(slide.explanation)"></p>
        </div>
      </div>

      <!-- Slide de Ejercicio de Desarrollo -->
      <div v-else-if="slide.type === 'exercise-development'" class="grid-1">
        <div class="question-icon">🤓</div>
        <h3 v-html="md(slide.questionTitle)"></h3>
        <p class="question-text-large" v-html="md(slide.question)"></p>
        <div class="development-guidelines">
          <h4>💡 <span v-html="md(slide.guidelinesTitle)"></span></h4>
          <div class="guidelines-grid">
            <div v-for="i in 6" :key="i">
              <div v-if="slide['guideline' + i]" class="guideline-item">
                <span class="guideline-icon">{{
                  slide["guideline" + i].icon
                }}</span>
                <span v-html="md(slide['guideline' + i].text)"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Ejercicio 3: Caso + Desarrollo con pistas -->
      <div v-else-if="slide.type === 'case-analysis'" class="grid-1">
        <div class="case-scenario-redesigned">
          <div class="scenario-header">
            <span class="scenario-icon">{{ slide.scenarioIcon }}</span>
            <h3 v-html="md(slide.scenarioTitle)"></h3>
          </div>
          <div class="scenario-content">
            <p v-html="md(slide.scenarioContent)"></p>
          </div>
        </div>
        <div class="case-question-redesigned">
          <div class="question-header">
            <span class="question-icon">❓</span>
            <h4 v-html="md(slide.questionTitle)"></h4>
          </div>
          <p class="question-content" v-html="md(slide.question)"></p>
        </div>
        <div class="analysis-hints-redesigned">
          <h4 v-html="md(slide.hintsTitle)"></h4>
          <div class="hints-container">
            <div v-for="i in 3" :key="i">
              <div v-if="slide['hint' + i]" class="hint-item">
                <span class="hint-number">{{ i }}</span>
                <span v-html="md(slide['hint' + i])"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Ejercicio 4: Caso Misterio + Alternativas -->
      <div v-else-if="slide.type === 'mystery-case'" class="grid-1">
        <div class="mystery-case">
          <div class="case-header">
            <span class="case-icon">{{ slide.caseIcon }}</span>
            <h3 v-html="md(slide.caseTitle)"></h3>
          </div>
          <div class="case-description">
            <p v-html="md(slide.caseDescription)"></p>
          </div>
        </div>
        <div class="mystery-question">
          <h4 v-html="md(slide.question)"></h4>
        </div>
        <div class="mystery-options">
          <div v-for="i in 4" :key="i">
            <div
              class="mystery-option"
              v-if="slide['option' + i]"
              :class="{ 'correct-option': slide['option' + i].isCorrect }"
            >
              <div class="option-letter">
                {{ { 1: "A", 2: "B", 3: "C", 4: "D" }[i] }}
              </div>
              <span class="option-icon">{{ slide["option" + i].icon }}</span>
              <div class="option-content-wrapper">
                <span v-html="md(slide['option' + i].text)"></span>
                <div v-if="slide['option' + i].isCorrect" class="correct-badge">
                  <span class="badge-icon">✅</span>
                  <span class="badge-text">¡Respuesta Correcta!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="slide.explanation" class="answer-explanation">
          <div class="explanation-header">
            <span class="explanation-icon">🎯</span>
            <h4>Explicación</h4>
          </div>
          <p v-html="md(slide.explanation)"></p>
        </div>
      </div>

      <!-- Ejercicio 5: Evaluación de Veracidad -->
      <div v-else-if="slide.type === 'truth-evaluation'" class="grid-1">
        <div class="final-case">
          <div class="case-header">
            <span class="case-icon">{{ slide.caseIcon }}</span>
            <h3 v-html="md(slide.caseTitle)"></h3>
          </div>
          <div class="case-story">
            <p v-html="md(slide.caseStory)"></p>
          </div>
        </div>
        <div class="assertion-section">
          <div class="assertion-header">
            <span class="assertion-icon">📋</span>
            <h4 v-html="md(slide.assertionTitle)"></h4>
          </div>
          <div class="assertion-content">
            <p>
              <strong v-html="md(slide.assertionStatement)"></strong>
            </p>
          </div>
        </div>
        <div class="final-question">
          <h4 v-html="md(slide.question)"></h4>
        </div>
        <div class="final-options">
          <div v-for="i in 4" :key="i">
            <div
              class="final-option"
              v-if="slide['option' + i]"
              :class="{ 'correct-option': slide['option' + i].isCorrect }"
            >
              <div class="option-letter">
                {{ { 1: "A", 2: "B", 3: "C", 4: "D" }[i] }}
              </div>
              <div class="option-content-wrapper">
                <div class="option-detail">
                  <span
                    class="option-title"
                    v-html="md(slide['option' + i].title)"
                  ></span>
                  <span
                    class="option-desc"
                    v-html="md(slide['option' + i].description)"
                  ></span>
                </div>
                <div v-if="slide['option' + i].isCorrect" class="correct-badge">
                  <span class="badge-icon">✅</span>
                  <span class="badge-text">¡Correcto!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="slide.explanation" class="answer-explanation">
          <div class="explanation-header">
            <span class="explanation-icon">🏆</span>
            <h4>Explicación</h4>
          </div>
          <p v-html="md(slide.explanation)"></p>
        </div>
      </div>

      <!-- Slide de Cierre -->
      <div v-else-if="slide.type === 'farewell'" class="grid-1">
        <div class="farewell-content">
          <div class="farewell-image">
            <img
              v-if="slide.promptimage1 && slide.promptimage1.startsWith('http')"
              :src="slide.promptimage1"
              alt="Imagen de despedida"
            />
            
          </div>

          <div class="farewell-message">
            <h2 v-html="md(slide.title)"></h2>
            <div class="farewell-text">
              <p v-html="md(slide.paragraph1)"></p>

              <div v-if="slide.keyLearningsTitle" class="key-learnings">
                <h4 v-html="md(slide.keyLearningsTitle)"></h4>
                <div class="learnings-grid">
                  <div v-for="i in 4" :key="i">
                    <div v-if="slide['learning' + i]" class="learning-item">
                      <span class="learning-icon">{{
                        slide["learning" + i].icon
                      }}</span>
                      <span v-html="md(slide['learning' + i].text)"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import assistedMaterialService from "../../services/assistedMaterialService";
import { inlineMarkdown } from "@/utils/inlineMarkdown";

// Tiempos de la aparicion de cada slide. Son pausas cortas a proposito: dan la
// sensacion de que la lamina se va construyendo, en vez de aparecer de golpe.
const PAUSA_ARMAZON_MS = 850;      // contornos dibujandose, antes del texto
const PAUSA_ANTES_IMAGEN_MS = 450; // el texto ya se leyo, entra la imagen
const PAUSA_TRAS_IMAGEN_MS = 550;  // se aprecia la lamina antes de la siguiente
// Tope de espera por una imagen. Pasado esto se sigue: mejor una lamina sin
// foto que una vitrina detenida.
const ESPERA_MAXIMA_IMAGEN_MS = 8000;
// Lo que dura el brillo de cierre antes de pasar a la siguiente lamina.
const DURACION_BRILLO_MS = 900;

// Función utilitaria para obtener el token CSRF de la cookie
// function getCookie(name) {
//   let cookieValue = null;
//   if (document.cookie && document.cookie !== "") {
//     const cookies = document.cookie.split(";");
//     for (let i = 0; i < cookies.length; i++) {
//       const cookie = cookies[i].trim();
//       if (cookie.substring(0, name.length + 1) === name + "=") {
//         cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
//         break;
//       }
//     }
//   }
//   return cookieValue;
// }

export default {
  name: "SingleSlideComponent",
  props: {
    index: {
      type: Number,
      required: true,
    },
    dailyPlanification: {
      type: Object,
      required: true,
    },
    // Demo mode (public planification demo): render `demoSlide` with a fake
    // streaming effect instead of fetching from the worker. Keeps `canRemake`
    // off so no path can reach the AI backends.
    demo: {
      type: Boolean,
      required: false,
      default: false,
    },
    demoSlide: {
      type: Object,
      required: false,
      default: null,
    },
    // Slide generada por el padre (PlanificationTable). Cuando viene, este
    // componente NO pide nada: solo refleja lo que el padre va escribiendo.
    //
    // El padre empieza a generar las slides mientras la planificacion todavia
    // se escribe, asi que para cuando el profesor llega abajo muchas ya estan
    // listas. Si este componente siguiera pidiendo la suya al montarse, cada
    // slide se generaria (y se pagaria) dos veces.
    slideExterna: {
      type: Object,
      required: false,
      default: null,
    },
  },
  created() {
    if (this.demo && this.demoSlide) {
      this.replayDemoSlide();
    } else if (this.slideExterna) {
      // La vitrina solo entrega slides ya terminadas, asi que se revela con
      // efecto de escritura en vez de aparecer entera de una.
      this.revelarSlide(this.slideExterna);
    } else {
      this.getSingleSlide(this.index);
    }
  },
  beforeDestroy() {
    if (this.demoReplayTimer) clearInterval(this.demoReplayTimer);
  },
  watch: {
    // El padre escribe la slide de a poco (streaming) y despues le agrega la
    // imagen: hay que reflejar cada cambio para que se vea construirse.
    slideExterna: {
      deep: true,
      handler(nueva) {
        // Mientras corre el revelado no se pisa: el efecto de escritura ya se
        // encarga de ir mostrando el contenido.
        if (nueva && !this.demoReplayTimer) {
          this.slide = Object.assign({}, this.slide, nueva);
        }
      },
    },
  },
  computed: {
    /**
     * La slide existe pero todavia no llega su contenido: el padre empuja un
     * `{}` como marcador de posicion y recien despues lo llena con el stream.
     * Mientras tanto se dibuja el contorno, como en materiales para la clase.
     */
    dibujando() {
      const s = this.slide || {};
      // Se mira si hay CUALQUIER contenido, no una lista de campos de titulo:
      // hay ocho titulos distintos segun el tipo de slide (title, title1,
      // question, questionTitle, scenarioTitle, observationsTitle,
      // analysisTitle, guidelinesTitle) y enumerar solo algunos dejaba a las
      // demas marcadas como "dibujandose" para siempre, con el contorno
      // animado encima de contenido real.
      //
      // `type` no cuenta: lo pone este componente al crear el objeto, antes de
      // que llegue nada del stream.
      return !Object.keys(s).some((k) => k !== "type" && s[k]);
    },
  },
  data() {
    return {
      slide: {},
      canRemake: false,
      // Evita pedir (y pagar) dos veces las imagenes de la misma slide.
      imagenPedida: false,
      // La lamina termino su coreografia: dispara el brillo de cierre.
      lista: false,
      demoReplayTimer: null,
    };
  },
  methods: {
    // Los modelos mandan `**negrita**` en la prosa aunque no se pida. Sin
    // esto el profesor ve los asteriscos crudos en la slide.
    md(value) {
      return inlineMarkdown(value);
    },
    /**
     * Pide las imagenes de la slide, una vez que llego TODO su texto.
     *
     * Se intento adelantar esta llamada al momento en que el prompt aparece en
     * el JSON parcial, pero no sirve: una slide puede traer hasta tres prompts
     * repartidos por el JSON, asi que disparar con el primero mandaba la slide
     * incompleta y las otras dos imagenes no se pedian nunca. La ganancia eran
     * ~2s de ~10s por slide; no compensaba el riesgo.
     *
     * Para acortar de verdad la espera hay que generar varias slides en
     * paralelo, no adelantar esta llamada.
     */
    pedirImagen(slideObj, index) {
      if (this.imagenPedida || !slideObj) return;
      this.imagenPedida = true;
      assistedMaterialService
        .getSingleSlideImage({ slide_data: slideObj, index: index })
        .then((data) => {
          this.slide = Object.assign({}, this.slide, data);
          this.$emit("slideUpdate", { index: index, slide: data });
        })
        .catch(() => {
          // Si falla, la slide se queda sin imagen: mejor eso que cortar la
          // cadena de slides.
        });
    },

    // Fake-stream the pre-recorded slide: feed its JSON through the same
    // partial-parse pipeline used by the real stream so the reveal looks
    // identical, then emit `slideDone` to keep the slide chain advancing.
    replayDemoSlide() {
      this.revelarSlide(this.demoSlide);
    },
    // Tiempos de la coreografia, en el orden en que ocurren.
    /**
     * Revela una slide ya generada con el mismo efecto de escritura del stream
     * real: se va armando el JSON de a pedazos y pintando lo que se puede
     * parsear. Asi una slide que ya estaba lista en el buffer se ve
     * construirse, en vez de aparecer de golpe.
     *
     * Es el mecanismo que ya usaba el demo publico; solo se generalizo para
     * recibir cualquier slide.
     */
    async revelarSlide(slideCompleta) {
      if (!slideCompleta) return;

      // --- Coreografia de aparicion, en tres tiempos ---
      //
      // Mostrar la slide entera de golpe (o dejar que la imagen entre junto con
      // el texto) se siente atropellado: el profesor no alcanza a leer nada. Se
      // separa en tiempos, como se lee una lamina de verdad.
      //
      // 1. El armazon: la tarjeta vacia dibuja sus contornos.
      // 2. El texto: entra con efecto de escritura.
      // 3. La imagen: recien al final, y con un fundido.
      const camposImagen = [
        "promptimage1", "promptimage2", "promptimage3",
        "promptparaimagen1", "promptimagen1", "promptimagen2", "promptimagen3",
      ];
      const imagenes = {};
      const sinImagenes = Object.assign({}, slideCompleta);
      camposImagen.forEach((c) => {
        if (sinImagenes[c]) {
          imagenes[c] = sinImagenes[c];
          delete sinImagenes[c];
        }
      });

      // 1. Tiempo del armazon: la tarjeta ya esta montada y vacia, asi que su
      //    animacion de contorno corre sola. Se le da aire antes del texto.
      await new Promise((r) => setTimeout(r, PAUSA_ARMAZON_MS));

      // 2. Tiempo del texto.
      await this.escribirSlide(sinImagenes);

      // 3. Tiempo de la imagen.
      //
      // Se descarga ANTES de ponerla en la slide. Si se pone la URL directo, el
      // navegador muestra el hueco mientras baja el archivo y se ve un cargando
      // feo justo al final de la coreografia. Precargada, entra de una con su
      // fundido.
      if (Object.keys(imagenes).length) {
        await new Promise((r) => setTimeout(r, PAUSA_ANTES_IMAGEN_MS));
        await this.precargarImagenes(Object.values(imagenes));
        this.slide = Object.assign({}, this.slide, imagenes);
        await new Promise((r) => setTimeout(r, PAUSA_TRAS_IMAGEN_MS));
      }

      this.slide = Object.assign({}, slideCompleta);

      // Brillo de cierre, el mismo gesto que usan las tarjetas de materiales
      // para la clase: le dice al profesor "esta lamina ya esta" antes de
      // pasar a la siguiente.
      this.lista = true;
      await new Promise((r) => setTimeout(r, DURACION_BRILLO_MS));

      this.$emit("slideDone", { index: this.index, slide: slideCompleta });
      this.$emit("revelada", { index: this.index });
    },
    /**
     * Baja las imagenes antes de mostrarlas, para que aparezcan completas.
     *
     * Nunca rechaza: una imagen rota o lenta no puede dejar la vitrina colgada,
     * asi que hay un tope de espera y despues se sigue igual.
     */
    precargarImagenes(urls) {
      const utiles = (urls || []).filter(
        (u) => typeof u === "string" && u.startsWith("http")
      );
      if (!utiles.length) return Promise.resolve();

      return Promise.all(
        utiles.map(
          (url) =>
            new Promise((resolve) => {
              const img = new Image();
              const listo = setTimeout(resolve, ESPERA_MAXIMA_IMAGEN_MS);
              const terminar = () => {
                clearTimeout(listo);
                resolve();
              };
              img.onload = terminar;
              img.onerror = terminar;
              img.src = url;
            })
        )
      );
    },
    /** Escribe la slide con el efecto de tecleo del stream real. */
    escribirSlide(slideCompleta) {
      return new Promise((resolve) => {
      const full = JSON.stringify(slideCompleta);
      const CHUNK_SIZE = 30;
      let buffer = "";
      let cursor = 0;
      this.demoReplayTimer = setInterval(() => {
        buffer += full.slice(cursor, cursor + CHUNK_SIZE);
        cursor += CHUNK_SIZE;
        try {
          this.slide = Object.assign({}, this.slide, JSON.parse(buffer));
        } catch (e) {
          try {
            this.slide = Object.assign(
              {},
              this.slide,
              JSON.parse(this.formatBuffer(buffer))
            );
          } catch (er) {
            // Partial JSON not yet parseable; keep buffering.
          }
        }
        if (cursor >= full.length) {
          clearInterval(this.demoReplayTimer);
          this.demoReplayTimer = null;
          this.slide = Object.assign({}, this.slide, slideCompleta);
          resolve();
        }
      }, 30);
      });
    },
    remake() {
      this.slide = {};
      this.$emit('slideUpdate', { index: this.index, slide: {} });
      this.getSingleSlide(this.index, true);
    },
    async getSingleSlide(index, remake) {
      this.canRemake = false;
      const slideType = {
        1: "intro",
        2: "strategies",
        3: "case-study",
        4: "metamorphosis",
        5: "development",
        6: "exercise-multiple",
        7: "exercise-development",
        8: "case-analysis",
        9: "mystery-case",
        10: "truth-evaluation",
        11: "farewell",
      };

      try {
        const slideObj = {
          type: slideType[index],
        };
        // const csrftoken = getCookie("csrftoken");
        const responseBody = await assistedMaterialService.getSingleSlideOnline(
          JSON.stringify({
            planification_crudo: this.dailyPlanification,
            index: index,
          })// ,
          // csrftoken
        );
        const reader = responseBody.getReader();
        const decoder = new TextDecoder();
        let buffer = "";
        let done = false;
        while (!done) {
          const { done: streamDone, value } = await reader.read();
          done = streamDone;
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          // console.log("[SlidesOnline] Chunk recibido:", chunk);
          buffer += chunk;
          if (buffer.startsWith("json")) {
            buffer = buffer.replace("json", "");
          }
          try {
            // let slideObj = JSON.parse(buffer);
            let partialSlide = JSON.parse(buffer);
            Object.assign(slideObj, partialSlide);
            this.slide = Object.assign({}, this.slide, slideObj);
            // this.slidesOnlineData.slides[index] = slideObj;
          } catch (e) {
            try {
              let formattedBuffer = this.formatBuffer(buffer);
              let partialSlide = JSON.parse(formattedBuffer);
              // let slideObj = JSON.parse(formattedBuffer);
              Object.assign(slideObj, partialSlide);
              this.slide = Object.assign({}, this.slide, slideObj);
              // this.slidesOnlineData.slides[index] = slideObj;
            } catch (e) {
              // console.warn("Invalid JSON at the moment", e);
            }
          }

          // console.log("estado buffer", buffer);
        }
        if (done && !remake) {
          this.canRemake = true;
          this.$emit("slideDone", { index: index, slide: slideObj });
        }
        // Procesar el buffer final si quedó algo
        if (buffer.trim()) {
          // console.log("[SlidesOnline] Procesando buffer final:", buffer);
          try {
            const slideObj = JSON.parse(buffer);
            slideObj.type = slideType[index];
            this.slide = Object.assign({}, this.slide, slideObj);
            this.$emit("slideUpdate", { index: index, slide: slideObj });
            // this.slidesOnlineData.slides[index] = slideObj;
            // console.log("[SlidesOnline] Slide final agregado:", slideObj);
          } catch (e) {
            // Ignorar error de parseo de línea final (puede estar vacía)
          }
        }
        // console.log(
        //   "[SlidesOnline] Estado final de slidesOnlineData:",
        //   this.slidesOnlineData
        // );
        this.pedirImagen(slideObj, index);
      } catch (err) {
        // this.slidesOnlineData = { slides: [] };
        // alert("Error de red al obtener slide online.");
        // console.error("[SlidesOnline] Error en fetch:", err);
      }
    },
    formatBuffer(buffer) {
      const pendingElements = [];
      let newBuffer = buffer;
      for (let i = 0; i < buffer.length; i++) {
        if (buffer[i] === "{") {
          pendingElements.push("{");
        }
        if (buffer[i] === "[") {
          pendingElements.push("[");
        }
        if (buffer[i] === '"') {
          if (
            pendingElements.length > 0 &&
            pendingElements[pendingElements.length - 1] === '"'
          ) {
            pendingElements.pop();
          } else {
            pendingElements.push('"');
          }
        }
        if (buffer[i] === "}") {
          if (
            pendingElements.length > 0 &&
            pendingElements[pendingElements.length - 1] === "{"
          ) {
            pendingElements.pop();
          }
        }
        if (buffer[i] === "]") {
          if (
            pendingElements.length > 0 &&
            pendingElements[pendingElements.length - 1] === "["
          ) {
            pendingElements.pop();
          }
        }
      }
      while (pendingElements.length > 0) {
        const lastElement = pendingElements.pop();
        if (lastElement === "{") {
          newBuffer += "}";
        } else if (lastElement === '"') {
          newBuffer += '"';
        } else if (lastElement === "[") {
          newBuffer += "]";
        }
      }
      return newBuffer;
    },
  },
};
</script>
<style scoped lang="scss">
/* Los encabezados de seccion comparten tamano (1.2rem) en todos los tipos de
   slide. .final-question y .assertion-header estaban en 1.1rem y el salto se
   notaba al pasar de una lamina a la siguiente. */
.slide {
  background: var(--bg-primary) !important;
  border-radius: var(--radius-lg) !important;
  overflow: hidden !important;
  box-shadow: var(--shadow-sm) !important;
  border: 1px solid var(--border) !important;
  transition: all 0.3s ease !important;
}

.slide:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

/* ---- Contorno que se dibuja antes de que llegue el contenido ----
   Misma tecnica que las tarjetas de materiales para la clase
   (MaterialStreamCards, keyframe borderSweep): un borde en ::after que arranca
   recortado del todo y se va revelando de izquierda a derecha, asi el profesor
   ve aparecer el marco de la slide y despues se llena con el texto y la imagen,
   en vez de mirar un hueco vacio. */
.slide.dibujando {
  position: relative;
}

.slide.dibujando:hover {
  transform: none;
}

.slide.dibujando::after {
  content: "";
  position: absolute;
  inset: 0;
  border: 2px solid var(--primary, #20b2aa);
  border-radius: var(--radius-lg);
  pointer-events: none;
  z-index: 3;
  clip-path: inset(0 100% 0 0);
  animation: slideBorderSweep 0.85s cubic-bezier(0.55, 0.05, 0.25, 1) forwards;
}



/* Mientras se dibuja, el encabezado vacio no debe verse como una barra suelta. */
.slide.dibujando .slide-header {
  opacity: 0;
}

@keyframes slideBorderSweep {
  to {
    clip-path: inset(0);
  }
}

/* Nota sobre el color: estos bloques (las pistas de la slide 8 y la afirmacion
   de la slide 10) usaban `var(--accent)`. El problema es que dos de las cuatro
   paletas comparten el mismo acento morado (#8C5383 en "Cian Vibrante" y en
   "Rojo Coral"), asi que al cambiar de paleta el morado se quedaba igual y en
   una lamina cian se leia como un color ajeno. Ahora usan `--primary`, que es
   el color que el profesor efectivamente eligio. */

/* ---- Brillo de cierre ----
   Portado de MaterialStreamCards (.card.complete:before / readyShine): cuando la
   lamina termino de armarse, un destello la recorre en diagonal. Es el mismo
   gesto que ya usa materiales para la clase, para que las dos partes del
   producto se sientan iguales. */
.slide::before {
  content: "";
  position: absolute;
  inset: -20% -35%;
  pointer-events: none;
  z-index: 6;
  background: linear-gradient(
    112deg,
    transparent 32%,
    rgba(255, 255, 255, 0.04) 39%,
    rgba(255, 255, 255, 0.38) 45%,
    rgba(248, 252, 255, 0.92) 49%,
    rgba(255, 247, 219, 0.55) 52%,
    rgba(238, 247, 255, 0.72) 55%,
    rgba(255, 255, 255, 0.22) 61%,
    transparent 69%
  );
  mix-blend-mode: screen;
  transform: translateX(-82%) rotate(3deg);
  opacity: 0;
}

.slide.lista::before {
  animation: slideBrilloCierre 1.05s cubic-bezier(0.35, 0.02, 0.18, 1) both;
}

@keyframes slideBrilloCierre {
  0% {
    opacity: 0;
    transform: translateX(-82%) rotate(3deg);
  }
  16% {
    opacity: 0.3;
  }
  36% {
    opacity: 0.92;
  }
  68% {
    opacity: 0.72;
  }
  100% {
    opacity: 0;
    transform: translateX(82%) rotate(3deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .slide.lista::before {
    animation: none;
  }
}

/* ---- El contorno se dibuja sobre los CONTENEDORES de verdad ----
   Antes esto apuntaba a `.slide-content > *` y a los hijos de las grillas, que
   son divs de maquetacion: no tienen fondo ni radio propio, asi que el contorno
   salia cuadrado y en lugares donde el profesor no ve ninguna tarjeta. La lista
   de abajo son los bloques que SI se ven como tarjeta (tienen fondo o borde y
   su propio radio), sacados del propio css de este componente. Con `inherit`
   ahora si heredan un radio de verdad y el trazo calza con la tarjeta.

   La animacion corre sola al montarse el elemento, o sea cuando el stream lo
   crea: no hace falta nada de JS y funciona para cualquier tipo de slide. */
.slide-header,
.slide-content .intro-capsule,
.slide-content .info-box,
.slide-content .main-image,
.slide-content .top-image,
.slide-content .feature,
.slide-content .stage-card-large,
.slide-content .answer-explanation,
.slide-content .option-card,
.slide-content .text-item,
.slide-content .key-learnings,
.slide-content .learning-item,
.slide-content .guideline-item,
.slide-content .hint-item,
.slide-content .analysis-hints-redesigned,
.slide-content .case-question-redesigned,
.slide-content .case-image-full,
.slide-content .mystery-question,
.slide-content .mystery-option,
.slide-content .final-case,
.slide-content .final-option,
.slide-content .final-question,
.slide-content .assertion-content,
.slide-content .farewell-image {
  position: relative;
}

.slide-header::after,
.slide-content .intro-capsule::after,
.slide-content .info-box::after,
.slide-content .main-image::after,
.slide-content .top-image::after,
.slide-content .feature::after,
.slide-content .stage-card-large::after,
.slide-content .answer-explanation::after,
.slide-content .option-card::after,
.slide-content .text-item::after,
.slide-content .key-learnings::after,
.slide-content .learning-item::after,
.slide-content .guideline-item::after,
.slide-content .hint-item::after,
.slide-content .analysis-hints-redesigned::after,
.slide-content .case-question-redesigned::after,
.slide-content .case-image-full::after,
.slide-content .mystery-question::after,
.slide-content .mystery-option::after,
.slide-content .final-case::after,
.slide-content .final-option::after,
.slide-content .final-question::after,
.slide-content .assertion-content::after,
.slide-content .farewell-image::after {
  content: "";
  position: absolute;
  inset: 0;
  border: 1.5px solid var(--primary, #20b2aa);
  border-radius: inherit;
  pointer-events: none;
  z-index: 4;
  opacity: 0.85;
  clip-path: inset(0 100% 0 0);
  animation: slideBlockSweep 1.1s cubic-bezier(0.55, 0.05, 0.25, 1) forwards;
}

/* Barre el borde y despues se desvanece, dejando la tarjeta como estaba. */
@keyframes slideBlockSweep {
  0% {
    clip-path: inset(0 100% 0 0);
    opacity: 0.85;
  }
  55% {
    clip-path: inset(0);
    opacity: 0.85;
  }
  100% {
    clip-path: inset(0);
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .slide.dibujando::after,
  .slide-header::after {
    animation: none;
    opacity: 0;
  }
}

.slide-header {
  background: var(--gradient-primary);
  color: white;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: all 0.3s ease;
}

.slide-number {
  background: rgba(255, 255, 255, 0.2);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  font-weight: 600;
  flex-shrink: 0;
}

.slide-title {
  font-size: 1.3rem;
  font-weight: 600;
}

.slide-content {
  padding: 0;
  min-height: 400px;
}

/* Layout Grid */
.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
  min-height: 400px;
}

.slide:nth-child(6) .slide-content,
.slide:nth-child(7) .slide-content,
.slide:nth-child(8) .slide-content,
.slide:nth-child(9) .slide-content,
.slide:nth-child(10) .slide-content,
.slide:nth-child(11) .slide-content,
.slide:nth-child(12) .slide-content {
  padding: 24px;
}

.grid-1 {
  width: 100%;
  display: grid;
  gap: 20px;
}

.text-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  justify-content: center;
}

.intro-text {
  font-size: 1.05rem;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.info-box {
  background: var(--primary-bg-medium);
  border: 1px solid var(--primary-border-light);
  border-radius: var(--radius-md);
  padding: 16px;
  transition: all 0.2s ease;
}

.info-box:hover {
  transform: translateY(-1px);
  border-color: var(--primary);
}

.info-box h3 {
  color: var(--primary-dark);
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-box p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
}

.features {
  display: grid;
  gap: 16px;
  padding: 24px;
  justify-content: center;
}

.feature {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: var(--bg-secondary);
  border-radius: var(--radius-md);
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.feature:hover {
  background: var(--bg-primary);
  border-color: var(--primary);
  transform: translateX(4px);
}

.feature-icon {
  font-size: 1.8rem;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gradient-primary);
  border-radius: 50%;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.feature:hover .feature-icon {
  transform: scale(1.05);
}

.feature-content h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.feature-content p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  line-height: 1.4;
  margin: 0;
}

.intro-capsule {
  text-align: center;
  width: 100%;
  padding: 20px;
  background: var(--primary-bg-light);
  border-radius: var(--radius-lg);
  border: 1px solid var(--primary-border-medium);
  margin-bottom: 16px;
}

.intro-capsule .intro-text {
  font-size: 1.1rem;
  color: var(--text-primary);
  font-weight: 500;
  margin-bottom: 8px;
}

.intro-capsule .subtitle {
  font-size: 1rem;
  color: var(--primary-dark);
  font-weight: 600;
}

.main-image {
  overflow: hidden;
  border: 2px solid var(--primary);
  border-radius: var(--radius-md);
  position: relative;
  width: 100%;
  height: 100%;
  transition: all 0.3s ease;
  margin: 24px;
  margin-left: 0;
  height: calc(100% - 48px);
}

.main-image:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.main-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.main-image:hover img {
  transform: scale(1.05);
}

/* Metamorfosis */
.metamorphosis-intro {
  text-align: center;
  padding: 20px;
  background: var(--primary-bg-light);
  border-radius: var(--radius-lg);
  border: 1px solid var(--primary-border-medium);
  margin-bottom: 24px;
}

.metamorphosis-intro .intro-text {
  font-size: 1.1rem;
  color: var(--text-primary);
  font-weight: 500;
  margin-bottom: 8px;
}

.metamorphosis-intro .subtitle {
  font-size: 1rem;
  color: var(--primary-dark);
  font-weight: 600;
}

.metamorphosis-grid-large {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  max-width: 1100px;
  margin: 0 auto;
}

.stage-card-large {
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  border: 3px solid var(--primary);
  transition: all 0.3s ease;
}

.stage-card-large:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg);
}

.stage-image-large {
  width: 100%;
  height: 250px;
  overflow: hidden;
  position: relative;
  background: var(--bg-tertiary);
}

.stage-image-large img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.stage-card-large:hover .stage-image-large img {
  transform: scale(1.08);
}

.stage-info {
  padding: 16px;
}

.stage-info h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.stage-info p {
  color: var(--text-secondary);
  font-size: 0.85rem;
  line-height: 1.4;
  margin: 0;
}

/* Desarrollo de Ideas */
.grid-2x2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 16px;
  max-width: 900px;
  margin: 0 auto;
  height: auto;
}

.top-image {
  width: 100%;
  height: 240px;
  border-radius: var(--radius-md);
  overflow: hidden;
  border: 2px solid var(--primary);
  margin-bottom: 24px;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
}

.top-image:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.top-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.top-image:hover img {
  transform: scale(1.05);
}

.text-item {
  background: var(--primary-bg-medium);
  border: 1px solid var(--primary-border-light);
  border-radius: var(--radius-md);
  padding: 16px;
  transition: all 0.3s ease;
  height: fit-content;
}

.text-item:hover {
  transform: translateY(-3px);
  border-color: var(--primary);
  box-shadow: var(--shadow-sm);
}

.text-item h3 {
  color: var(--primary-dark);
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.text-item .emoji {
  font-size: 1.3rem;
}

.text-item p {
  color: var(--text-secondary);
  font-size: 0.85rem;
  line-height: 1.4;
  margin: 0;
}

/* Case Study Layout */
.case-study-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* Tres filas: (observaciones | analisis), la tabla completa, y la imagen. */
  grid-template-rows: auto auto auto;
  gap: 32px;
  align-items: start;
}

.observations-section {
  grid-column: 1;
  grid-row: 1;
}

.analysis-section {
  grid-column: 2;
  grid-row: 1;
}

.case-table-full {
  grid-column: 1 / -1;
  grid-row: 2;
  width: 100%;
}

.case-table-full .analysis-table {
  width: 100%;
}

.case-image-full {
  grid-column: 1 / -1;
  grid-row: 3;
  width: 100%;
  height: 300px;
  border-radius: var(--radius-md);
  overflow: hidden;
  border: 2px solid var(--primary);
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
  margin-top: 16px;
}

.case-image-full:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.case-image-full img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.case-image-full:hover img {
  transform: scale(1.05);
}

.section-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--primary-dark);
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--primary);
}

.observations-list {
  list-style: none;
  padding: 0;
  margin: 0 0 24px 0;
}

.observations-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px;
  background: var(--bg-secondary);
  border-radius: var(--radius-sm);
  border-left: 4px solid var(--primary);
  transition: all 0.2s ease;
}

.observations-list li:hover {
  background: var(--bg-primary);
  transform: translateX(4px);
}

.observations-list li::before {
  content: "•";
  color: var(--primary);
  font-weight: bold;
  font-size: 1.2rem;
  flex-shrink: 0;
  margin-top: 2px;
}

.observations-list li span {
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.4;
}

/* Tabla de análisis */
.analysis-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--bg-primary);
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  margin-top: 16px;
}

.analysis-table th {
  background: var(--gradient-primary);
  color: white;
  padding: 14px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 0.9rem;
}

.analysis-table td {
  padding: 12px;
  border-bottom: 1px solid var(--border);
  font-size: 0.9rem;
  color: var(--text-secondary);
  vertical-align: top;
}

.analysis-table tr:last-child td {
  border-bottom: none;
}

.analysis-table tr:hover {
  background: var(--bg-secondary);
}

.analysis-table .animal-name {
  font-weight: 600;
  color: var(--text-primary);
}

/* Ejercicios */
.exercise-question {
  width: 100%;
  text-align: center;
  background: var(--primary-bg-light);
  padding: 24px;
  border-radius: var(--radius-lg);
  border: 2px solid var(--primary-border-medium);
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.exercise-question:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
}

.exercise-question h3 {
  color: var(--text-primary);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.exercise-options {
  width: 100%;
  display: grid;
  gap: 12px;
  margin-bottom: 24px;
}

.option-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: var(--bg-primary);
  border: 2px solid var(--border);
  border-radius: var(--radius-md);
  transition: all 0.3s ease;
  cursor: pointer;
}

.option-card:hover {
  border-color: var(--primary);
  transform: translateX(8px);
  box-shadow: var(--shadow-sm);
}

.correct-option {
  width: 100%;
  background: var(--primary-bg-light);
  border: 2px solid var(--primary);
  box-shadow: var(--shadow-sm);
}

.correct-option:hover {
  transform: translateX(4px);
  box-shadow: var(--shadow-md);
}

.option-content-wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.correct-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.3);
  border-radius: var(--radius-sm);
  width: fit-content;
}

.badge-icon {
  font-size: 1rem;
}

.badge-text {
  color: rgba(34, 197, 94, 0.9);
  font-weight: 600;
  font-size: 0.85rem;
}

.answer-explanation {
  width: 100%;
  background: var(--primary-bg-medium);
  border: 2px solid var(--primary-border-light);
  border-radius: var(--radius-lg);
  padding: 20px;
  transition: all 0.3s ease;
}

.explanation-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.explanation-icon {
  font-size: 1.3rem;
}

.explanation-header h4 {
  color: var(--primary-dark);
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.answer-explanation p {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
}

.option-letter {
  width: 32px;
  height: 32px;
  background: var(--gradient-primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  flex-shrink: 0;
}

.option-card p {
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.4;
}

/* Ejercicio 2 */
.development-question-large {
  text-align: center;
  background: var(--primary-bg-light);
  padding: 36px 32px;
  border-radius: var(--radius-lg);
  border: 3px solid var(--primary-border-medium);
  margin-bottom: 32px;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-md);
}

.development-question-large:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.question-icon {
  font-size: 2rem;
  margin-bottom: 12px;
}

.development-question-large h3 {
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 16px;
}

.question-text-large {
  color: var(--text-secondary);
  font-size: 1.2rem;
  line-height: 1.6;
  margin: 0;
  font-style: italic;
  font-weight: 500;
  max-width: 900px;
  margin: 0 auto;
}

.development-guidelines {
  margin-bottom: 24px;
}

.development-guidelines h4 {
  color: var(--primary-dark);
  font-size: 1.1rem;
  margin-bottom: 16px;
  text-align: center;
}

.guidelines-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.guideline-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: var(--bg-secondary);
  border-radius: var(--radius-sm);
  border-left: 4px solid var(--primary);
  transition: all 0.2s ease;
}

.guideline-item:hover {
  background: var(--bg-primary);
  transform: translateX(4px);
}

.guideline-icon {
  font-size: 1.2rem;
}

/* Case Analysis (Ejercicio 3) */
.case-scenario-redesigned {
  background: var(--primary-bg-light);
  border: 2px solid var(--primary-border-medium);
  border-radius: var(--radius-lg);
  padding: 24px;
  margin-bottom: 24px;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
}

.case-scenario-redesigned:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.scenario-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.scenario-icon {
  font-size: 1.5rem;
}

.scenario-header h3 {
  color: var(--primary-dark);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.scenario-content p {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
  text-align: justify;
}

.case-question-redesigned {
  background: var(--primary-bg-medium);
  border: 2px solid var(--primary-border-medium);
  border-radius: var(--radius-lg);
  padding: 24px;
  margin-bottom: 24px;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
}

.case-question-redesigned:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.question-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.question-header h4 {
  color: var(--primary-dark);
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.question-content {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  font-style: italic;
}

.analysis-hints-redesigned {
  background: var(--bg-secondary);
  border: 2px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 20px;
  transition: all 0.3s ease;
}

.analysis-hints-redesigned h4 {
  color: var(--primary-dark);
  font-size: 1.1rem;
  margin-bottom: 16px;
  text-align: center;
}

.hints-container {
  display: grid;
  gap: 8px;
}

.hint-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: var(--bg-primary);
  border-radius: var(--radius-sm);
  border-left: 3px solid var(--primary);
  transition: all 0.2s ease;
}

.hint-item:hover {
  transform: translateX(4px);
  box-shadow: var(--shadow-sm);
}

.hint-number {
  width: 24px;
  height: 24px;
  background: var(--primary);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  flex-shrink: 0;
}

/* Ejercicios 4 y 5 */
.mystery-case,
.final-case {
  background: var(--primary-bg-light);
  border: 2px solid var(--primary-border-medium);
  border-radius: var(--radius-lg);
  padding: 24px;
  margin-bottom: 24px;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
}

.mystery-case:hover,
.final-case:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.case-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.case-icon {
  font-size: 1.5rem;
}

.case-header h3 {
  color: var(--primary-dark);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.case-description,
.case-story {
  width: 100%;
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.6;
  text-align: justify;
}

.mystery-question,
.final-question {
  width: 100%;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 20px;
  padding: 20px;
  background: var(--primary-bg-medium);
  border-radius: var(--radius-lg);
  border: 2px solid var(--primary-border-medium);
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
}

.mystery-question:hover,
.final-question:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.mystery-options,
.final-options {
  display: grid;
  width: 100%;
  gap: 12px;
  margin-bottom: 24px;
}

.mystery-option,
.final-option {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
  padding: 16px;
  background: var(--bg-primary);
  border: 2px solid var(--border);
  border-radius: var(--radius-md);
  transition: all 0.3s ease;
  cursor: pointer;
}

.mystery-option:hover,
.final-option:hover {
  border-color: var(--primary);
  transform: translateX(6px);
  box-shadow: var(--shadow-sm);
}

.option-content {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
}

.option-icon {
  font-size: 1.2rem;
}

.option-detail {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
}

.option-title {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.95rem;
}

.option-desc {
  color: var(--text-secondary);
  font-size: 0.85rem;
}

/* Ejercicio 5 específico */
.assertion-section {
  background: var(--primary-bg-medium);
  border: 2px solid var(--primary-border-medium);
  border-radius: var(--radius-lg);
  padding: 24px;
  width: 100%;
  margin-bottom: 24px;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
}

.assertion-section:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.assertion-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.assertion-icon {
  font-size: 1.3rem;
}

.assertion-header h4 {
  color: var(--primary-dark);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.assertion-content {
  text-align: center;
  padding: 16px;
  width: 100%;
  background: var(--bg-primary);
  border-radius: var(--radius-md);
  border-left: 4px solid var(--primary);
}

.assertion-content p {
  color: var(--text-primary);
  font-size: 1.1rem;
  line-height: 1.5;
  margin: 0;
  font-style: italic;
}

/* Slide de Cierre */
.farewell-content {
  display: grid;
  gap: 24px;
  width: 100%;
}

.farewell-image {
  width: 100%;
  height: 250px;
  border-radius: var(--radius-lg);
  overflow: hidden;
  border: 3px solid var(--primary);
  box-shadow: var(--shadow-md);
}

.farewell-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.farewell-image:hover img {
  transform: scale(1.05);
}

.farewell-message {
  text-align: center;
  width: 100%;
}

.farewell-message h2 {
  color: var(--text-primary);
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 20px;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.farewell-text p {
  color: var(--text-secondary);
  font-size: 1.05rem;
  line-height: 1.6;
  width: 100%;
  text-align: justify;
  margin-bottom: 24px;
}

.key-learnings {
  background: var(--primary-bg-light);
  border: 2px solid var(--primary-border-medium);
  border-radius: var(--radius-lg);
  padding: 20px;
  width: 100%;
  margin-bottom: 24px;
}

.key-learnings h4 {
  color: var(--primary-dark);
  font-size: 1.1rem;
  margin-bottom: 16px;
}

.learnings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
}

.learning-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: var(--bg-primary);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  transition: all 0.2s ease;
}

.learning-item:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
  border-color: var(--primary);
}

.learning-icon {
  font-size: 1.3rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .container {
    gap: 16px;
  }

  .hero {
    padding: 24px 20px;
  }

  .hero h1 {
    font-size: 1.8rem;
  }

  .hero p {
    font-size: 1rem;
  }

  .grid-2 {
    grid-template-columns: 1fr;
    gap: 0;
    min-height: auto;
  }

  .text-section {
    padding: 20px;
  }

  .features {
    padding: 20px;
  }

  .main-image {
    height: 200px;
    margin: 20px;
    margin-left: 0;
    height: 200px;
    border-radius: var(--radius-md);
  }

  .metamorphosis-grid-large {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .stage-image-large {
    height: 200px;
  }

  .grid-2x2 {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .case-study-layout {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .case-image-full {
    grid-column: 1;
    grid-row: auto;
  }

  .analysis-table {
    font-size: 0.85rem;
  }

  .analysis-table th,
  .analysis-table td {
    padding: 10px 8px;
  }

  .palette-grid {
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
  }

  .color-palette-selector {
    padding: 16px;
    margin-bottom: 16px;
  }

  .exercise-options,
  .mystery-options,
  .final-options {
    gap: 10px;
  }

  .option-card,
  .mystery-option,
  .final-option {
    padding: 14px;
    gap: 12px;
  }

  .option-letter {
    width: 28px;
    height: 28px;
    font-size: 0.9rem;
  }

  .option-card p,
  .option-content {
    font-size: 0.9rem;
  }

  .development-question-large {
    padding: 20px;
  }

  .question-text-large {
    font-size: 1rem;
  }

  .guidelines-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .guideline-item {
    padding: 10px;
  }

  .case-scenario-redesigned,
  .mystery-case,
  .final-case {
    padding: 16px;
  }

  .scenario-content p,
  .case-description,
  .case-story {
    font-size: 0.95rem;
  }

  .farewell-message h2 {
    font-size: 1.5rem;
  }

  .farewell-text p {
    font-size: 1rem;
  }

  .learnings-grid {
    grid-template-columns: repeat(1, 1fr);
    gap: 10px;
  }

  .learning-item {
    padding: 10px;
    gap: 8px;
  }

  .farewell-image {
    height: 200px;
  }
}

/* Mejoras de Accesibilidad */
@media (prefers-reduced-motion: reduce) {
  *,
  ::before,
  ::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

.slide:focus-within {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
}

.exercise-question:hover,
.development-question-large:hover,
.mystery-question:hover,
.final-question:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
}

.case-scenario-redesigned,
.mystery-case,
.final-case,
.exercise-question,
.development-question-large,
.case-question-redesigned,
.mystery-question,
.final-question {
  transition: all 0.3s ease;
}

/* --- NUEVO: Tarjeta visual para cada slide --- */
.slide-card {
  background: #f4fcfd;
  border: 2px solid #b2e4ea;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(32, 178, 170, 0.07);
  margin: 32px auto;
  max-width: 900px;
  overflow: hidden;
  transition: box-shadow 0.3s;
}
.slide-card:hover {
  box-shadow: 0 8px 32px rgba(32, 178, 170, 0.13);
}
/* Ajusta los bordes de los elementos internos para que sean redondeados y no sobresalgan */
.slide-card .main-image,
.slide-card .top-image,
.slide-card .farewell-image,
.slide-card .case-image-full {
  border-radius: 14px;
  overflow: hidden;
}
.slide-card .stage-card-large,
.slide-card .option-card,
.slide-card .mystery-option,
.slide-card .final-option,
.slide-card .text-item,
.slide-card .guideline-item,
.slide-card .hint-item,
.slide-card .learning-item {
  border-radius: 12px;
}
/* Ajusta el padding de slide-content para que el contenido no toque los bordes */
.slide-content {
  padding: 32px 24px;
}
/* Tarjeta especial para desarrollo */
.slide-card-development {
  background: #f4fcfd;
  border: 2px solid #b2e4ea;
  border-radius: 18px;
  padding: 32px 24px;
  margin: 0 auto 32px auto;
  max-width: 700px;
  box-shadow: 0 2px 12px rgba(32, 178, 170, 0.07);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.grid-1 .question-icon,
.grid-1 h3,
.grid-1 .question-text-large {
  text-align: center;
}
.grid-1 h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--text-primary);
}
.grid-1 .question-text-large {
  font-size: 1.15rem;
  color: var(--text-secondary);
  font-style: italic;
  font-weight: 500;
  margin: 0 auto 24px auto;
  max-width: 900px;
  line-height: 1.6;
}

.prompt-english {
  background: #f5f5f5;
  color: #333;
  font-size: 0.95em;
  padding: 8px;
  border-radius: 6px;
  margin-top: 8px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
